import { useState } from 'react';
import { Form } from 'antd';

const useMachineForm = (initialValues, onFinish, mode) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setVisible(true);
  };

  const hideModal_Ok = async () => {
    try {
      const values = await form.validateFields();
      // Ensure user is set to null if not selected
      if (!values.user) {
        values.user = null;
      }
      onFinish(values);
      setVisible(false);
    } catch (error) {
      console.log('Validation failed:', error);
    }
  };

  const hideModal_Cancel = () => {
    setVisible(false);
  };

  const form_onFinish = async (values) => {
    // Ensure user is set to null if not selected
    if (!values.user) {
      values.user = null;
    }
    await onFinish(values);
    setVisible(false);
  };

  return {
    form,
    visible,
    showModal,
    hideModal_Ok,
    hideModal_Cancel,
    form_onFinish,
  };
};

export default useMachineForm;
